<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'NOT_DELIVERED_REASON', url: '/admin/not-delivered-reason' },
    { label: 'UPDATE_NOT_DELIVERED_REASON' }
  ]"
></breadcrumbs>
<page-header title="UPDATE_NOT_DELIVERED_REASON"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="TEXT">{{
        'TEXT' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="text"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['text'])"
          [ngClass]="{ 'is-danger': hasError('text') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('text')">
        {{ getError('text') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
      (click)="onSubmit($event)"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/not-delivered-reason']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
